import api from '@/services/Api';
import { ListWrapper } from '@/models/ListWrapper'
import { ErpStoreClient } from '@/models/repairModule/erpStore/ErpStoreClient'

class ErpStoreService {
  async getItechStoreClientList(storeId) {
    const response = await api.get('/distributor/erp-store/list/' + storeId)

    let erpStoreClientList = []
    for (let item of response.data.item_list) {
      let erpStoreClient = new ErpStoreClient(
        item.technical_id,
        item.client_code,
        item.client_name,
        item.client_postal_code,
        item.client_store_code,
      )
      erpStoreClientList.push(erpStoreClient)
    }

    return new ListWrapper(
      response.data.count,
      erpStoreClientList
    )
  }

  async generateOT(data) {
    const response = await api.post(
      '/distributor/erp-store/generate-ot',
      data)

    return response.data
  }
}

export default new ErpStoreService()
